import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HeaderComponent, FooterComponent } from './layouts';
import { AuthenticationService, CommonService, TokenInterceptor } from './services';
import { OnlyNumberDirective, BlockCopyPasteDirective } from './directives';
import { IndianCurrency, SumPipe, SafePipe } from './pipes';
import {NgxPaginationModule} from 'ngx-pagination';
import { NgxCaptchaModule } from 'ngx-captcha';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NgxPaginationModule,
        NgxCaptchaModule

    ],
    declarations: [
        HeaderComponent,
        FooterComponent,
        IndianCurrency, SumPipe, SafePipe,
        OnlyNumberDirective, BlockCopyPasteDirective
    ],
    providers: [
        AuthenticationService,
        CommonService
    ],
    exports: [
        CommonModule,
        FormsModule,
        RouterModule,
        HeaderComponent,
        FooterComponent,
        IndianCurrency, SumPipe, SafePipe,
        OnlyNumberDirective,
        BlockCopyPasteDirective, NgxPaginationModule, NgxCaptchaModule
    ]
})
export class SharedModule { }
